// utils.js

// Function to generate a unique password
const generateUniquePassword = () => {
    //return 'Test@' + Math.random().toString(36).slice(-8);
    return 'Test@123456'; // temporary password
  };
  
  // Export the generateUniquePassword function
  module.exports = {
    generateUniquePassword
  };
  